import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { faChevronLeft, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useState } from "react";
import { store } from "react-notifications-component";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Button,
	CardLink,
	FormGroup,
	Input,
	Label,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Spinner,
} from "reactstrap";
import { Dispatch } from "redux";
import { settingAction } from "../../actions/settingAction";
import {
	DABButton,
	DABTextBox,
	LoadingSpinnerModal,
} from "../../components/dab";
import { getLoggedUserId } from "../../services/selectors/Accounts";
import { showAlert } from "../common/functions";

interface SettingProps {
	dispatch: Dispatch<any>;
	settingData: any;
}

const SettingList: React.SFC<SettingProps> = ({ dispatch, settingData }) => {
	const history = useHistory();

	const [showModal, setShowModal] = useState(false);
	const [showLoading, setShowLoading] = useState(false);
	const [updateLoading, setUpdateLoading] = useState(false);
	const [isOpenEdit, setOpenEdit] = useState(false);
	const [editedId, setEditedId] = useState(null);
	const [descriptionError, setDescriptionError] = useState(false);
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [modalHeader, setModalHeader] = useState("Record a Video Details");

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	React.useEffect(() => {
		dispatch(settingAction.settingGetList());
		setShowModal(true);
	}, []);

	React.useEffect(() => {
		if (isOpenEdit === true) {
			setShowLoading(true);
			dispatch(settingAction.getSettingContent(editedId));
		}
	}, [isOpenEdit]);

	React.useEffect(() => {
		if (settingData?.settingContent) {
			setTitle(settingData?.settingContent?.title);
			setDescription(settingData?.settingContent?.descriptionHtml);
		}
	}, [settingData?.settingContent]);

	React.useEffect(() => {
		if (settingData?.isUpdateStatus) {
			dispatch(settingAction.settingGetList());
			const alertMessage = settingData?.status;
			settingData.isUpdateStatus = false;
			if (alertMessage && alertMessage != "") {
				store.addNotification({
					title: "Success!",
					message: alertMessage,
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				window.localStorage.setItem("alertMessage", "");
			}
		}
	}, [settingData?.isUpdateStatus]);
	React.useEffect(() => {
		if (settingData?.isUpdateContent && settingData?.isSuccess) {
			dispatch(settingAction.settingGetList());
			const alertMessage = settingData?.status;
			settingData.isUpdateContent = false;
			setUpdateLoading(false);
			setOpenEdit(false);
			if (alertMessage && alertMessage != "") {
				store.addNotification({
					title: "Success!",
					message: alertMessage,
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				window.localStorage.setItem("alertMessage", "");
			}
		}
	}, [settingData?.isUpdateContent]);

	if (settingData && !settingData.isLoading && settingData.isListSuccess) {
		settingData.isListSuccess = false;
		if (showModal) {
			setShowModal(false);
		}
	}

	if (settingData && !settingData.showLoading && settingData.isDetailSuccess) {
		settingData.isDetailSuccess = false;
		if (showLoading) {
			setShowLoading(false);
		}
	}

	if (settingData && !settingData.isSuccess && settingData.isError) {
		if (settingData.status === "Unauthorized") {
			history.push("/401");
		} else {
			showAlert(settingData.status, true);
		}
		settingData.isError = false;
		setUpdateLoading(false);
		if (showModal) {
			setShowModal(false);
		}
	}

	const handleSave = async (event) => {
		event?.preventDefault();
		event?.stopPropagation();
		setDescriptionError(false);
		if (description === "" || description === "<p>&nbsp;</p>") {
			setDescriptionError(true);
			return;
		}
		setUpdateLoading(true);
		const data = {
			messageBoard: {
				title: title,
				descriptionHtml: description,
				messageBoardId: editedId,
			},
		};
		await dispatch(settingAction.updateSettingContent(data));
		// setOpenEdit(false);
		// setUpdateLoading(false);
	};

	const handleClose = (event) => {
		event?.preventDefault();
		event?.stopPropagation();
		setOpenEdit(false);
		setDescriptionError(false);
		setTitle("");
		setDescription("");
	};

	const handleActiveModule = async (id: any, status: any, key: string) => {
		setShowModal(true);
		const data = {
			messageBoardId: id,
			adminUserId: parseInt(getLoggedUserId()),
			isEnabled: !status,
			communityItemId:
				key === "recordvideo"
					? 0
					: key === "watch"
					? 1
					: key === "prayer"
					? 2
					: key === 'prayerhotlinechannel'
					? 4
					: 3,
		};
		await dispatch(settingAction.updateSettingStatus(data));
	};

	return (
		<div data-testid="settingPage" className="setting-page">
			<div className="card-box-link-back-div">
				<FontAwesomeIcon icon={faChevronLeft} />
				<CardLink
					onClick={() => history.push("/")}
					className="card-box-link-back"
					data-testid="bible-backtolist"
				>
					Back to List
				</CardLink>
			</div>
			<div className="setting-table">
				<table className="table table-hover" data-testid="settingTable">
					<thead data-testid="settingTableHead">
						<tr>
							<th scope="col" data-testid="detail-th">
								Details
							</th>
							<th style={{ width: "80%" }} scope="col" data-testid="name-th">
								Record a Video
							</th>
							<th style={{ width: "20%" }} scope="col" data-testid="status-th">
								Status
							</th>
						</tr>
					</thead>
					<tbody data-testid="settingTableBody">
						{settingData &&
							settingData?.items?.recordVideoList?.map((data: any) => (
								<>
									<tr key={data.messageBoardId}>
										<th scope="row" className="icon-column">
											<FontAwesomeIcon
												size="2x"
												icon={faEdit}
												data-testid="settingDetailButton"
												title="Details"
												cursor="pointer"
												className="detailButton"
												onClick={() => {
													setOpenEdit(true);
													setModalHeader("Record a Video Details");
													setEditedId(data.messageBoardId);
												}}
											/>
										</th>
										<td id="name">{data.title} </td>
										<td id="activeInactiveSwitch" className="text-center">
											<FormGroup switch>
												<Input
													type="switch"
													className="active-switch"
													id="activeInactiveSwitch"
													data-testid="activeInactiveSwitch"
													checked={data?.isEnabled}
													onChange={() =>
														handleActiveModule(
															data.messageBoardId,
															data?.isEnabled,
															"recordvideo"
														)
													}
												/>
											</FormGroup>
										</td>
									</tr>
								</>
							))}
					</tbody>
				</table>
			</div>
			<div className="setting-table mt-5">
				<table className="table table-hover" data-testid="watchsettingTable">
					<thead data-testid="watchsettingTableHead">
						<tr>
							<th scope="col" data-testid="detail-th">
								Details
							</th>
							<th style={{ width: "80%" }} scope="col" data-testid="name-th">
								Watch
							</th>
							<th style={{ width: "20%" }} scope="col" data-testid="status-th">
								Status
							</th>
						</tr>
					</thead>
					<tbody data-testid="watchsettingTableBody">
						{settingData &&
							settingData?.items?.watchList?.map((data: any) => (
								<>
									<tr key={data.messageBoardId}>
										<th scope="row" className="icon-column">
											{data.uniqueCode !== "contextual-media" && (
												<FontAwesomeIcon
													size="2x"
													data-testid="settingDetailButton"
													icon={faEdit}
													title="Details"
													cursor="pointer"
													className="detailButton"
													onClick={() => {
														setOpenEdit(true);
														setModalHeader("Watch Details");
														setEditedId(data.messageBoardId);
													}}
												/>
											)}
										</th>
										<td id="name">{data.title} </td>
										<td id="watchactiveInactiveSwitch" className="text-center">
											<FormGroup switch>
												<Input
													type="switch"
													className="active-switch"
													id="watchactiveInactiveSwitch"
													checked={data?.isWatchEnabled}
													onChange={() =>
														handleActiveModule(
															data.messageBoardId,
															data?.isWatchEnabled,
															"watch"
														)
													}
												/>
											</FormGroup>
										</td>
									</tr>
								</>
							))}
					</tbody>
				</table>
			</div>
			<div className="setting-table mt-5">
				<table className="table table-hover" data-testid="prayersettingTable">
					<thead data-testid="prayersettingTableHead">
						<tr>
							<th style={{ width: "80%" }} scope="col" data-testid="name-th">
								Prayer/Meditation & Talks
							</th>
							<th style={{ width: "20%" }} scope="col" data-testid="status-th">
								Status
							</th>
						</tr>
					</thead>
					<tbody data-testid="prayersettingTableBody">
						{settingData && settingData?.items?.recordVideoList && (
							<>
								<tr
									key={
										settingData?.items?.prayerAndMeditation?.channelAssignmentId
									}
								>
									<td id="name">Prayer & Meditation</td>
									<td id="prayeractiveInactiveSwitch" className="text-center">
										<FormGroup switch>
											<Input
												type="switch"
												className="active-switch"
												id="prayeractiveInactiveSwitch"
												checked={
													settingData?.items?.prayerAndMeditation?.isEnabled
												}
												onChange={() =>
													handleActiveModule(
														settingData?.items?.prayerAndMeditation
															?.channelAssignmentId,
														settingData?.items?.prayerAndMeditation?.isEnabled,
														"prayer"
													)
												}
											/>
										</FormGroup>
									</td>
								</tr>
								<tr key={settingData?.items?.talks?.channelAssignmentId}>
									<td id="name">Talks</td>
									<td id="talksactiveInactiveSwitch" className="text-center">
										<FormGroup switch>
											<Input
												type="switch"
												className="active-switch"
												id="talksactiveInactiveSwitch"
												checked={settingData?.items?.talks?.isEnabled}
												onChange={() =>
													handleActiveModule(
														settingData?.items?.talks?.channelAssignmentId,
														settingData?.items?.talks?.isEnabled,
														"talk"
													)
												}
											/>
										</FormGroup>
									</td>
								</tr>
							</>
						)}
					</tbody>
				</table>
			</div>
			<div className="setting-table mt-5">
				<table className="table table-hover" data-testid="prayerHotlineSettingTable">
					<thead data-testid="prayerHotlineSettingTableHead">
						<tr>
							<th style={{ width: "80%" }} scope="col" data-testid="name-th">
								Prayer Hotline Channel
							</th>
							<th style={{ width: "20%" }} scope="col" data-testid="status-th">
								Status
							</th>
						</tr>
					</thead>
					<tbody data-testid="prayerHotlineSettingTableBody">
						{settingData &&
							settingData?.items?.prayerHotlineChannelList?.map((data: any) => {
								return (
									<tr key={data.messageBoardId}>
										<td id="name">{data.title} </td>
										<td
											id="prayerHotlineActiveInactiveSwitch"
											className="text-center"
										>
											<FormGroup switch>
												<Input
													type="switch"
													className="active-switch"
													id="prayerHotlineActiveInactiveSwitch"
													checked={data?.isPrayerHotlineChannelEnabled}
													onChange={() =>
														handleActiveModule(
															data.messageBoardId,
															data?.isPrayerHotlineChannelEnabled,
															"prayerhotlinechannel"
														)
													}
												/>
											</FormGroup>
										</td>
									</tr>
								);
							})}
						{settingData &&
							!settingData?.items?.prayerHotlineChannelList?.length && (
								<tr>
									<td
										colSpan={2}
										className="text-center"
										data-testid="prayerHotlineNoChannelMessage"
									>
										No channels available. Please enable the Prayer Hotline
										Channel from Manage Message Board to see the list here.
									</td>
								</tr>
							)}
					</tbody>
				</table>
			</div>
			{showModal && (
				<LoadingSpinnerModal
					isShowModal={showModal}
					modalChange={handleLoadShowModal}
				/>
			)}
			<Modal isOpen={isOpenEdit} backdrop="static" size="xl" centered>
				<ModalHeader>{modalHeader}</ModalHeader>
				<form name="updateform" onSubmit={handleSave}>
					{showLoading ? (
						<div className="text-center my-3">
							<Spinner />
						</div>
					) : (
						<>
							<ModalBody>
								<FormGroup>
									<Label
										for="videoTitle"
										data-testid="videoTitle"
										className="col-form-label"
									>
										Title
									</Label>
									<DABTextBox
										type="text"
										id="videoTitle"
										data-testid="videoTitle"
										isRequired={true}
										isHover={false}
										onChange={(event) => {
											const value = event.target.value;
											setTitle(value);
										}}
										value={title}
										pattern=".*\S.*"
										title="Input cannot be only spaces"
										maxLength={30}
										readonly={editedId === 75} 
									/>
									{title?.length >= 30 && (
										<span className="text-warning">
											Character limit met. Maximum 30 characters allowed
										</span>
									)}
								</FormGroup>
								<FormGroup>
									<Label
										for="ruleDescription"
										data-testid="roleDescTitle"
										className="col-form-label"
									>
										Rule Description
									</Label>
									<div data-testid="description-editor">
										<CKEditor
											editor={ClassicEditor}
											data={description}
											id="descriptionEditor"
											config={{
												toolbar: [
													"heading",
													"|",
													"bold",
													"italic",
													"underline",
													"strikethrough",
													"|",
													"numberedList",
													"bulletedList",
													"|",
													"undo",
													"redo",
												],
											}}
											onChange={(_, editor) => {
												const data = editor.getData();
												setDescription(data);
											}}
										/>
									</div>
									{descriptionError && (
										<span className="text-warning">
											Rule Description is required.
										</span>
									)}
								</FormGroup>
							</ModalBody>
							<ModalFooter>
								<DABButton
									id="backToCreate"
									onClick={handleClose}
									value="CANCEL"
								>
									CANCEL
								</DABButton>
									<Button type="submit" color="secondary" className="btn-submit-frm">
										{updateLoading && <Spinner size="sm"></Spinner>} SAVE
									</Button>
							</ModalFooter>
						</>
					)}
				</form>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { settingData } = state;
	return {
		settingData,
	};
};

export default connect(mapStateToProps)(SettingList);
